import { generateSignature } from "../utils/security";

export async function callBackend(functionName = "bookingService", action, payload = {}) {
  const wrappedPayload = { action, ...payload };

  const apiSecret =
    process.env.REACT_APP_PLATFORM_API_SECRET ||
    process.env.REACT_APP_API_SECRET;
  
  const baseUrl =
    process.env.REACT_APP_BACKEND_URL ||
    "https://asia-south1-ganesh-holiday-homes.cloudfunctions.net";

  const cleanBase = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;

  const bookingServiceUrl =
    process.env.REACT_APP_BOOKING_SERVICE_URL ||
    new URL("bookingService", cleanBase).toString();
  
  // Normalize legacy function name to modern bookingService
  const resolvedFunctionName =
    functionName === "backendBookingService" ? "bookingService" : functionName;

  // Route directly to configured service using new URL
  const url =
    resolvedFunctionName === "bookingService"
      ? bookingServiceUrl
      : new URL(resolvedFunctionName.replace(/^\//, ""), cleanBase).toString();
  // -----------------------------------
  // 1) Create signature
  // -----------------------------------
  const { signature, timestamp } = generateSignature(
    wrappedPayload,
    action,
    apiSecret
  );

  // -----------------------------------
  // 2) Set headers for HTTPS request
  // -----------------------------------
  const headers = {
    "Content-Type": "application/json",
    "x-api-key": signature,
    "x-timestamp": timestamp,
  };

  // -----------------------------------
  // 3) Call backend using fetch
  // -----------------------------------
  try {
    const response = await fetch(url, {
      method: "POST",
      headers,
      body: JSON.stringify(wrappedPayload),
    });

    if (!response.ok) {
      let errorMsg = `HTTP ${response.status}`;
      try {
        const errorData = await response.json();
        errorMsg = errorData.error || errorData.message || errorMsg;
      } catch { }

      const err = new Error(errorMsg);
      if (response.status >= 500 || response.status === 404) {
        err.isServiceDown = true;
      }
      throw err;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("❌ Backend Error:", err);
    // Mark network connection failures as service down
    if (err.name === "TypeError" || !navigator.onLine) {
      err.isServiceDown = true;
    }
    throw err;
  }
}
